import { QRCode } from '@/components/Elements/QRCode/QRCode';
import { SxProps, Theme, Typography, Grid, Box, Button } from '@mui/material';
import { ReactNode } from 'react';
import Layout from './Layout';
import { Icon } from '@/components/Elements/Icons/Icon';
import TransitionTopButton from './TransitionTopButton';
import { ColorPalettes } from '../../../../../patient/src/features/reservation/constants/ColorPalettes';
import { ClinicProps } from '../types/Props';

interface TextProps {
  children: ReactNode;
  sx?: SxProps<Theme>;
  classNames?: string[];
}

const defaultTextSx: SxProps<Theme> = { mb: '14px' };
const defaultClassNames = ['font-bold', 'text-gray-500', 'text-center'];

const Text = ({ children, sx = defaultTextSx, classNames = [...defaultClassNames, 'sm:text-xl'] }: TextProps) => {
  const className = classNames.join(' ');
  return (
    <Typography sx={sx} className={className}>
      {children}
    </Typography>
  );
};

function LINEFriendAdd({ clinicName }: ClinicProps) {
  return (
    <Layout flowName="当日予約" clinicName={clinicName || undefined}>
      <Text sx={{ ...defaultTextSx, mt: '32px' }} classNames={[...defaultClassNames, 'sm:text-3xl']}>
        以下のQRコードを読み取って{<Icon icon="line" />}で友達追加してください
      </Text>
      <Text sx={{ ...defaultTextSx, mb: '32px' }} classNames={[...defaultClassNames, 'sm:text-3xl']}>
        友達追加後、LINEから直接本日のご予約が可能です
      </Text>
      <QRCode value={`https://line.me/ti/p/${import.meta.env.VITE_LINE_MESSAGING_API_BOT_ID}`} size={280} />
      <Grid
        container
        justifyContent={'center'}
        alignItems={'center'}
        spacing={2}
        sx={{ position: 'absolute', left: '0', mt: '-32px' }}
      >
        <Grid item>
          <Text
            sx={{ ...defaultTextSx, mt: '32px', whiteSpace: 'pre-line' }}
            classNames={[...defaultClassNames, 'sm:text-2xl']}
          >
            操作に不安がある方・その他のご質問は、<br></br>
            右の番号までお気軽にお電話ください
          </Text>
        </Grid>
        <Grid item>
          <Text
            sx={{ ...defaultTextSx, mt: '32px', whiteSpace: 'pre-line' }}
            classNames={[...defaultClassNames, 'sm:text-5xl']}
          >
            TEL：0120-341-019
          </Text>
        </Grid>
      </Grid>
      <Box sx={{ mt: '13%' }}>
        <TransitionTopButton
          title="受付TOPに戻る"
          flow="top"
          sx={{
            bgcolor: ColorPalettes.WHITE,
            color: ColorPalettes.MAIN,
            border: '1px solid',
            borderColor: ColorPalettes.MAIN
          }}
        />
      </Box>
    </Layout>
  );
}

export default LINEFriendAdd;
